import React from "react";
import "./GameCard.css";

function GameCard({ data }) {
  return (
    <div className="card">
      <div className="card-border-top"></div>

      {/* Game Image */}
      <div className="img">
        <img
          src={require(`../../assets/images/${data.logo}`)}
          alt={"Zesty games - " + data.title}
        />
      </div>

      {/* Game Title */}
      <span className="Cardtitle">{data.title}</span>

      {/* Play Now Button */}
      <button onClick={() => window.open(`/game/${data.shortUrl}`, "_blank")}>
        Play Now
      </button>
    </div>
  );
}

export default GameCard;
